import { layoutTypes } from './item.outlet.types';

export const setIsDelete = (flag: boolean) => ({
  type: layoutTypes.DELETE_MY_ITEM,
  payload: flag,
});
